module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    attrs: {
      "id": "formulario-top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        _vm.desde = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        _vm.hasta = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "ducto",
      "id": "ducto",
      "options": _vm.ductos,
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.setEstaciones($event)
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3"
  }, [_c('select-c', {
    attrs: {
      "name": "estaciones",
      "id": "estaciones",
      "options": _vm.estaciones,
      "placeholder": "ESTACIONES"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select-c', {
    attrs: {
      "name": "separacion",
      "id": "separacion",
      "options": _vm.options,
      "placeholder": "SEPARACION"
    }
  })], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body",
    attrs: {
      "id": "app"
    }
  }, [_c('line-chart', {
    attrs: {
      "id": "line",
      "data": _vm.line,
      "xkey": "year",
      "ykeys": "[ \"and\", \"ios\", \"win\" ]",
      "line-colors": "[ \"#FF0000\", \"#36A2EB\", \"#FFCE56\" ]",
      "grid": "true",
      "grid-text-weight": "bold",
      "resize": "true"
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " checkbox col-sm-2",
    attrs: {
      "id": "check"
    }
  }, [_c('label', {
    staticClass: "text-uppercase"
  }, [_c('input', {
    attrs: {
      "id": "auto-refresh",
      "type": "checkbox",
      "value": "true"
    }
  }), _vm._v("auto-refrescar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "id": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light"
  }, [_vm._v("\n          Buscar\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-12 nomen"
  }, [_c('h4', [_vm._v("Nomenclatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr', {
    staticStyle: {
      "background-color": "red",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#36A2EB",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "background-color": "#FFCE56",
      "height": "3px",
      "width": "50px",
      "margin-bottom": "35px!important",
      "margin-top": "15px!important"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("REP SALAMANCA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA ELENA")]), _vm._v(" "), _c('p', {
    staticClass: "nomen-p"
  }, [_vm._v("VS STA MONICA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c99c86a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reportes/Presion.vue
// module id = 1693
// module chunks = 6